"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangeSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _DateTime = require("../utils/DateTime");
var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));
var _ManageDateField = require("./managedField/ManageDateField");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Provides a multi-field component that manages a date range, from some date in the past until another date. The user can select the time range, 
 * or set the start or end dates directly. The start date can be "Any" (or all)
 * 
 * The caller must pass the following props:
 * 
 *  onDateChange:   a callback function whenever either start or end date changes. The callback is passed two params (start, end) date in JsonDateString format 
 *                  if the start date is "Any", null is returned
 *                  
 *  onParseError:   a callback function if the parsing of the date fails. The callback is passed an error message.
 *  
 *  
 *  The caller may pass the following props:
 * 
 *  allowFuture:    if true, future dates are permitted, if false, the end date cannot be more than today
 *  calendarColor:  color of the calendar icon, if not specified, default is gray
 *  dateFormat:     a DateUtils.DateFormatType value, if not specified, default is ISO8601
 *  minYear:        the minimum year on the calendars, if not specified, 1900
 *  maxYear:        the maximum year on the calendar, if not specified, this year
 *  
 *  timeOptions:    an array of objects used to specified the available date ranges working backward from today.  Each object must contain:
 *                       label: sets the menu display, 
 *                       startTime: is the desired start time in milliseconds since the epoch, or null for ANY
 *                       endTime: is the desired end time in milliseconds since the epoch, or null for TODAY
 *                       
 *                  For example:
 *  
 *                  {label: "Today", startTime: DateUtils.startOfToday().valueOf(), endTime: null}
 *                  
 *                  If timeOptions isn't specified, the date-range selector widget is hidden.
 *                  
 *  initialTimeRange:      the initial time range label, which must match one of the timeOptions (must supply this if timeOptions is defined)
 *  initialStartDate:      a JsonDateString of the initial Start time, if not supplied defaults to "Any"
 *  initialEndDate:        a JsonDateString object of the initial End time, if not suppied defaults to "Today"
 */
var DateRangeSelector = exports.DateRangeSelector = /*#__PURE__*/function (_Component) {
  function DateRangeSelector(props) {
    var _this;
    _classCallCheck(this, DateRangeSelector);
    _this = _callSuper(this, DateRangeSelector, [props]);
    _defineProperty(_this, "_calendarColor", 'gray');
    _defineProperty(_this, "_dateFormat", _DateTime.DateUtils.DateFormatType.ISO8601);
    _defineProperty(_this, "_timeOptions", void 0);
    _defineProperty(_this, "_onDateChange", void 0);
    _defineProperty(_this, "_onParseError", void 0);
    _defineProperty(_this, "_maxYear", new Date().getFullYear());
    //this year
    _defineProperty(_this, "_minYear", 1900);
    _defineProperty(_this, "_startDateFieldRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "_endDateFieldRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "_initialStart", void 0);
    _defineProperty(_this, "_initialEnd", void 0);
    _defineProperty(_this, "state", {});
    _defineProperty(_this, "_notifyOfDateChange", function () {
      if (_this._onDateChange) {
        var start = _this._startDateFieldRef.current.get();
        var end = _this._endDateFieldRef.current.get();
        _this._onDateChange(start === "Any" ? null : start, end);
      }
    });
    //Called when user selects a new time range from the dropdown,
    //set the end date to today and start date to the date picked
    _defineProperty(_this, "_timeRangeChanged", function () {
      //Find the selected start time
      var startTime;
      var endTime;
      var _iterator = _createForOfIteratorHelper(_this._timeOptions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var option = _step.value;
          if (_this.state.selectedTimeRange === option.label) {
            //found the selected one in the time options
            startTime = option.startTime;
            endTime = option.endTime;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (startTime == null) {
        //Set to "Any"
        _this._startDateFieldRef.current.change("Any", true);
      } else {
        var startDate = _DateTime.DateUtils.dateFormat(new Date(startTime), _this._dateFormat); // time incorrect on new Date() but we're only extracting the date portion anyway       
        _this._startDateFieldRef.current.change(startDate, true);
      }
      if (endTime == null) {
        //Set to Today
        var today = _DateTime.DateUtils.startOfToday();
        _this._endDateFieldRef.current.change(_DateTime.DateUtils.dateFormat(today, _this._dateFormat), true); // time incorrect on new Date() but we're only extracting the date portion anyway             
      } else {
        var endDate = _DateTime.DateUtils.dateFormat(new Date(endTime), _this._dateFormat); // time incorrect on new Date() but we're only extracting the date portion anyway               
        _this._endDateFieldRef.current.change(endDate, true);
      }
    });
    _defineProperty(_this, "_startDateChanged", function (json, val) {
      var today = _DateTime.DateUtils.startOfToday();
      var inputDate = val ? _DateTime.DateUtils.parseJsonDate(val, false) : null;
      if (inputDate && inputDate > today) _this._startDateFieldRef.current.change(_DateTime.DateUtils.dateFormat(today, _this._dateFormat), true);else _this._startDateFieldRef.current.accept();
      _this._notifyOfDateChange();
    });
    //If the end date is set to null ("Today" button) or a date after today, adjust it to today
    _defineProperty(_this, "_endDateChanged", function (json, val) {
      var today = _DateTime.DateUtils.startOfToday();
      var inputDate = val ? _DateTime.DateUtils.parseJsonDate(val, false) : null;
      if (inputDate && inputDate > today && !_this.props.allowFuture)
        // prevent future dates, unless allowFuture is true
        _this._endDateFieldRef.current.change(_DateTime.DateUtils.dateFormat(today, _this._dateFormat), true);else _this._endDateFieldRef.current.accept();
      _this._notifyOfDateChange();
    });
    _defineProperty(_this, "_dateParseError", function (label, error) {
      _this._onParseError(error);
    });
    if (props.calendarColor) _this._calendarColor = props.calendarColor;
    if (props.dateFormat) _this._dateFormat = props.dateFormat;
    _this._timeOptions = props.timeOptions;
    if (props.minYear) _this._minYear = props.minYear;
    if (props.maxYear) _this._maxYear = props.maxYear;
    _this._onDateChange = props.onDateChange;
    _this._onParseError = props.onParseError;
    _this.state.selectedTimeRange = props.initialTimeRange;
    _this.state.selectedTimeRangeValue = props.initialTimeRange;
    if (props.initialStartDate) _this._initialStart = props.initialStartDate;else _this._initialStart = "Any";
    if (props.initialEndDate) _this._initialEnd = props.initialEndDate;else _this._initialEnd = _DateTime.DateUtils.dateFormat(_DateTime.DateUtils.startOfToday(), _this._dateFormat);
    return _this;
  }
  _inherits(DateRangeSelector, _Component);
  return _createClass(DateRangeSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, this._timeOptions ? /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
        size: "small",
        value: this.state.selectedTimeRange,
        onChange: function onChange(event, newValue) {
          _this2.setState({
            selectedTimeRange: newValue
          });
        },
        inputValue: this.state.selectedTimeRangeValue,
        onInputChange: function onInputChange(event, newValue) {
          _this2.setState({
            selectedTimeRangeValue: newValue
          });
        },
        onClose: function onClose() {
          setTimeout(_this2._timeRangeChanged, 1); /*call after a slight delay to propagate state*/
        },
        options: this._timeOptions.map(function (option) {
          return option.label;
        }),
        blurOnSelect: true,
        disableClearable: true,
        openText: "Select Time Range",
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_react["default"].createElement(_core.TextField, _extends({}, params, {
            label: "Time Range",
            variant: "outlined",
            InputLabelProps: {
              shrink: true
            }
          }));
        }
      }) : null, /*#__PURE__*/_react["default"].createElement(_ManageDateField.ManageDateField, {
        hasNever: true,
        neverText: "Any",
        json: "startDateField",
        maxYear: this._maxYear,
        minYear: this._minYear,
        onFieldChange: this._startDateChanged,
        onParseError: this._dateParseError,
        label: "From",
        initialValue: this._initialStart,
        ref: this._startDateFieldRef,
        style: {
          marginTop: 10
        },
        changedBackgroundColor: "white",
        dateFormat: this._dateFormat,
        calendarColor: this._calendarColor,
        isReadOnly: false,
        editable: true
      }), /*#__PURE__*/_react["default"].createElement(_ManageDateField.ManageDateField, {
        hasNever: true,
        neverText: "Today",
        json: "endDateField",
        maxYear: this._maxYear,
        minYear: this._minYear,
        onFieldChange: this._endDateChanged,
        onParseError: this._dateParseError,
        label: "To",
        initialValue: this._initialEnd,
        ref: this._endDateFieldRef,
        style: {
          marginTop: 10
        },
        changedBackgroundColor: "white",
        dateFormat: this._dateFormat,
        calendarColor: this._calendarColor,
        isReadOnly: false,
        editable: true
      }));
    }
  }]);
}(_react.Component);